import { render, staticRenderFns } from "./CampoModalidadPago.vue?vue&type=template&id=25450c40"
import script from "./CampoModalidadPago.vue?vue&type=script&lang=js"
export * from "./CampoModalidadPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports